'use strict';

export default function f(deslug) {
  'ngInject';

  return (s) => {
    return deslug.it(s);
  };
}



// WEBPACK FOOTER //
// ./app/src/filters/deslug.filter.js